/* eslint-disable no-unused-vars */
import React, { useState, useRef } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import {
    FilterContainer,
    Title,
    SurgeryIcon,
    Icon,
    CloseIcon,
    IconContainer,
    OptionsContainer,
    StyledImage,
    CalendarPanelHeader,
    ContentContainer,
    ButtonLabel,
    FilterPopover,
} from './Panel.Styled';
import TabMenu from './tabMenu/TabMenu';
import SearchBox from 'src/common/refactoredComponents/searchbox';
import Plus from 'src/assets/images/Add.svg';
import CloseWhite from 'src/assets/images/CloseWhite.svg';
import Search from 'src/assets/images/Search.svg';
import SearchDark from 'src/assets/images/SearchDark.svg';
import FilterLight from 'src/assets/images/FilterLight.svg';
import FilterActiveLight from 'src/assets/images/FilterActiveLightNew.svg';
import FilterDark from 'src/assets/images/FilterDark.svg';
import FilterActiveDark from 'src/assets/images/FilterActiveDark.svg';
import Filter from 'src/common/refactoredComponents/filter/Filters';
import { useHistory } from 'react-router-dom';
import { setSearchParam, getSearchCardData } from 'src/pages/home/redux/actions';
import {
    setCalendarView,
    setFilterPopoverOpen,
} from 'src/pages/home/redux/actions';
import Button from 'src/common/components/button/Button';
import { sizes } from 'src/styles/Media.styled';
import {
    getBannerHeight,
    isMobileDevice,
    checkImpersonationActive,
    checkProxyActive,
} from 'src/utils/util';

/**
 * Library Imports
 */
import { useTranslation } from 'react-i18next';
import { scheduleSurgeryWCMSLink } from 'src/constants/wcmsRedirectionLinks';
import { handleScheduleSurgeryClick, logErrorToConsole } from 'src/utils/util';
import {
    getPageVisibilityForUser,
    getUser,
} from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import { PAGE_VISIBILITY_RULE ,PROXY,VISIBLE } from 'src/constants/appConstants';
import {
    resetBomData,
    reSetProgressBarStatus,
    resetSurgeryDetails,
    resetSurgeryDetailsReducer,
    resetShipToAddress,
    resetCreateOrUpdateSurgery,
} from 'src/pages/scheduleSurgery/redux/actions';
import { getConfigurations, setIsMastOrder, setPediatricCheck } from 'src/common/redux/actions';
import { resetNotes } from 'src/common/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const Panel = (props) => {
    const { openModal } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isActiveSearch, setActiveSearch] = useState(false);
    const [isOption] = useState(false);
    const [isFilterDisable, setIsFilterDisable] = useState(false);
    const history = useHistory();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { createOrderDetails,calendarPage } = useSelector((state) => state.loginReducer);

    const monthTab = {
        id: 'Month',
        displayName: t('calendar.calendarPanel.monthLabel'),
    };
    const weekTab = {
        id: 'Week',
        displayName: t('calendar.calendarPanel.weekLabel'),
    };
    const listTab = {
        id: 'List',
        displayName: t('calendar.calendarPanel.listLabel'),
    };

    const tabList = !isMobileDevice()
        ? [monthTab, weekTab, listTab]
        : [monthTab, weekTab];
    const filterIconEl = useRef(null);
    const isFilterPopoverOpen = useSelector(
        (state) => state.filterReducer.isFilterPopoverOpen
    );
    const filterPopoverId = anchorEl ? 'simple-popover' : undefined;

    const isMobileView = window.innerWidth <= sizes.mediumDevice;

    const selectedTab = useSelector(
        (state) => state.filterReducer.calendarView
    );

    // const isFilterOpen = useSelector(
    //     (state) => state.filterReducer.isFilterPopoverOpen
    // );

    const displayFilters = useSelector(
        (state) => state.appliedFiltersReducer.displayFilters,
        shallowEqual
    );

    const isSearchParamPresentInReducer =
        useSelector((state) => state.filterReducer.searchParam)?.length > 0
            ? true
            : false;

    useEffectWithErrorLogging(() => {
        localStorage.setItem('pageName', `Calendar-${selectedTab}-View`);
        if (!isMobileView) {
            setActiveSearch(true);
        } else {
            setActiveSearch(false);
        }
    }, [selectedTab]);

    useEffectWithErrorLogging(() => {
        if (isFilterPopoverOpen) {
            openFilterPopOver();
        }
    }, [isFilterPopoverOpen]);

    useEffectWithErrorLogging(() => {
        setActiveSearch(isSearchParamPresentInReducer);
    }, [isSearchParamPresentInReducer]);

    const selectTab = (selectedTab) => {
        dispatch(setCalendarView(selectedTab));
        localStorage.setItem('lastSelDLPCalView', selectedTab);
        setSelectedTabOptions(tabList.includes(selectedTab));
    };

    const setSelectedTabOptions = (listTabSelected) => {
        setActiveSearch(listTabSelected);
        // setIsFilterDisable(!listTabSelected);
        setIsFilterDisable(false);
    };

    const openFilterPopOver = (event) => {
        setAnchorEl(filterIconEl.current);
        dispatch(setFilterPopoverOpen(true));
    };

    const handleClose = () => {
        dispatch(setFilterPopoverOpen(false));
        setAnchorEl(null);
    };

    const openSearch = (e) => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        setActiveSearch(true);
        //disable filter option
        if (window.innerWidth < sizes.mobileDevice) {
            setIsFilterDisable(true);
        }

        //  console.log('disable filter');
    };

    const hideSearch = () => {
        setActiveSearch(false);
        setIsFilterDisable(false);
        dispatch(setSearchParam(''));
        // dispatch(
        //     getCardData({
        //         ...userFilters,
        //         searchParam: '',
        //     })
        // );
        document.getElementsByClassName('calender-wrapper')[0].style.display =
            '';
    };
    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    const [calendarMarginMobile, setCalnederMarginMobile] = useState('');

    useEffectWithErrorLogging(() => {
        setCalnederMarginMobile(
            bannerHeight ? getBannerHeight(bannerHeight, '7.4rem') : ''
        );
    }, [bannerHeight]);

    const searchParam = useSelector((state) => state.filterReducer.searchParam);
    const [searchValue, setSearchValue] = useState(searchParam || '');
    useEffectWithErrorLogging(() => {
        setSearchValue(searchParam || '');
    }, [searchParam]);

    // Handler for search input change
    const handleSearchChange = (e) => {
        setSearchValue(e.target.value.slice(0, 12));
    };

    // Handler for search input key down
    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (searchValue.trim().length > 0) {
                //hide calendar for mobile device only.
                window.innerWidth <= sizes.mobileDevice
                    ? (document.getElementsByClassName(
                          'calender-wrapper'
                      )[0].style.display = 'none')
                    : null;
                dispatch(setSearchParam(searchValue.trim()));
                dispatch(
                    getSearchCardData({ searchParam: searchValue.trim() })
                );
                document.activeElement.blur();
                openModal();
            }
        }
    };

    // Handler for clearing search
    const handleClearSearch = () => {
        setSearchValue('');
    };

    // Handler for blur
    const handleBlur = () => {
        if (isMobileDevice() && bannerHeight && bannerHeight !== '') {
            window.scrollTo(0, 0);
        }
    };

    // const enableOrderButtonBasedOnUser = () => {
    //     let showButton = false;
    //     const pageVisibilityRule = getPageVisibilityForUser(getUser());
    //     pageVisibilityRule.map((page) => {
    //         if (
    //             page &&
    //             page.pageRule.name === PAGE_VISIBILITY_RULE.name &&
    //             page.pageRule.rule === PAGE_VISIBILITY_RULE.rule
    //         ) {
    //             showButton = true;
    //         }
    //     });
    //     console.log('order button show', showButton);
    //     return showButton;
    // };

    return (
        <>
            <CalendarPanelHeader calnederMargin={calendarMarginMobile}>
                <ContentContainer
                    isImpersonationActive={checkImpersonationActive()}
                >
                    <Title>{t('common.calendarLabel')}</Title>
                    <OptionsContainer>
                        <TabMenu
                            tabList={tabList}
                            selectedTab={selectedTab}
                            selectTab={selectTab}
                            setSelectedTabOptions={setSelectedTabOptions}
                        />
                    </OptionsContainer>

                    <FilterContainer>
                        {!isOption && (
                            <>
                                {!isActiveSearch ? (
                                    <IconContainer
                                    id="home-calendarpanel-search-icon-container"
                                        onClick={() => {
                                            try {
                                                openSearch();
                                            } catch (error) {
                                                  logErrorToConsole(error);
                                            }
                                        }}
                                    >
                                        <Icon
                                            id="calendarPanel-search-icon"
                                            mobilePath={SearchDark}
                                            deskPath={Search}
                                            isApplyFilter={!isActiveSearch}
                                        />
                                    </IconContainer>
                                ) : (
                                    <>
                                        <CloseIcon>
                                            <StyledImage
                                            id="home-calendarpanel-close-search-image"
                                                src={CloseWhite}
                                                alt="Close"
                                                onClick={() => {
                                                    try {
                                                        hideSearch();
                                                    } catch (error) {
                                                       logErrorToConsole(error);
                                                   }
                                                }}
                                                width="auto"
                                                height="auto"
                                            />
                                        </CloseIcon>
                                        {isActiveSearch && window.innerWidth > sizes.mobileDevice &&
                                        <SearchBox
                                            id="calendar-desktop-searchbox"
                                            isCalendar={true}
                                            isActiveSearch={!isActiveSearch}
                                            openModal={openModal}
                                            updateSearch={handleSearchChange}
                                            searchProduct={searchValue}
                                            placeholder={t('calendar.calendarPanel.searchBox.placeholder')}
                                            width={window.innerWidth <= sizes.smalDevice
                                                ? '100%'
                                                : window.innerWidth <= sizes.mediumDevice ? '305px' : '358px'}
                                            marginDesktop={'0px 15px 0px 15px'}
                                            height={'40px'}
                                            borderRadius={'25px'}
                                            paddingLeft={'1.8rem'}
                                            placeholderPaddingLeft={'8px'}
                                            borderLeft={'none'}
                                            paddingRight={'10px'}
                                            isSearchIcon={true}
                                            searchIconWidth={'min-content'}
                                            margin={'0px'}
                                            fontSize={'16px'}
                                            placeHolderFontFamily={'AvenirNextWorld Regular'}
                                            iconColor={'#140F4B'}
                                            fontWeight={'bold'}
                                            handleKeyPress={handleSearchKeyDown}
                                            onBlur={handleBlur}
                                            clearSearch={handleClearSearch}
                                            background={'none'}
                                            enterkeyhint={'go'}
                                            iconPaddingLeft={'0px'}
                                        />}
                                    </>
                                )}
                                {!displayFilters.length ? (
                                    <IconContainer
                                     id="home-calendarpanel-filter-icon-container"
                                        ref={filterIconEl}
                                        onClick={(event) => {
                                            try {
                                                if (!isFilterDisable) {
                                                    openFilterPopOver(event);
                                                }
                                            } catch (err) {
                                               logErrorToConsole(err);
                                            }
                                        }}
                                    >
                                        <Icon
                                            id="calendarPanel-filter-icon"
                                            aria-describedby={filterPopoverId}
                                            mobilePath={FilterDark}
                                            deskPath={FilterLight}
                                            isApplyFilter={!isActiveSearch}
                                        />
                                    </IconContainer>
                                ) : (
                                    <IconContainer
                                     id="home-calendarpanel-filter-active-icon-container"
                                        ref={filterIconEl}
                                        onClick={(event) => {
                                            try {
                                                if (!isFilterDisable) {
                                                    openFilterPopOver(event);
                                                }
                                            } catch (err) {
                                                logErrorToConsole(err);
                                            }
                                        }}
                                    >
                                        <Icon
                                            id="calendarPanel-filter-active-icon"
                                            aria-describedby={filterPopoverId}
                                            mobilePath={FilterActiveDark}
                                            deskPath={FilterActiveLight}
                                            isApplyFilter={!isActiveSearch}
                                        />
                                    </IconContainer>
                                )}
                            </>
                        )}
                    </FilterContainer>

                    {calendarPage === VISIBLE &&
                        createOrderDetails.scheduleSurgery && (
                            <Button
                            id="home-calendarpanel-schedule-surgery-button"
                                height={'38px'}
                                width={'108px'}
                                surgery
                                show={true}
                                clicked={() => {
                                    try {
                                    sessionStorage.removeItem('myCaseRefID');
                                    dispatch(setIsMastOrder(false));
                                    dispatch(reSetProgressBarStatus());
                                    dispatch(resetSurgeryDetailsReducer());
                                    dispatch(resetShipToAddress());
                                    dispatch(resetCreateOrUpdateSurgery());
                                    dispatch(setPediatricCheck(''));
                                    dispatch(resetSurgeryDetails());
                                    dispatch(resetBomData());
                                    dispatch(resetNotes());
                                    localStorage.removeItem(
                                        'alertDatesforConsignmentAdd'
                                    );
                                    handleScheduleSurgeryClick(
                                        history,
                                        scheduleSurgeryWCMSLink
                                    );
                                    checkProxyActive() && dispatch(
                                        getConfigurations(
                                            {
                                                resourceType: 'visibility',
                                                module: PROXY,
                                            },
                                            PROXY
                                        )
                                    );
                                    } catch (error) {
                                        logErrorToConsole(error);
                                     }
                                }}
                            >
                                <SurgeryIcon>
                                    <StyledImage
                                        src={Plus}
                                        width="auto"
                                        height="auto"
                                        alt="+"
                                    />
                                </SurgeryIcon>
                                <ButtonLabel>
                                    {t('calendar.calendarPanel.surgeryButton')}
                                </ButtonLabel>
                            </Button>
                        )}
                    {/* </a> */}
                </ContentContainer>
            </CalendarPanelHeader>
            {isActiveSearch && window.innerWidth <= sizes.mobileDevice && (
                <SearchBox
                    id="calendar-mobile-searchbox"
                    isCalendar={true}
                    isActiveSearch={!isActiveSearch}
                    openModal={openModal}
                    updateSearch={handleSearchChange}
                    searchProduct={searchValue}
                    placeholder={t('calendar.calendarPanel.searchBox.placeholder')}
                    width={'100%'}
                    height={'36px'}
                    borderRadius={'5px'}
                    paddingLeft={'1.8rem'}
                    borderLeft={'none'}
                    paddingRight={'10px'}
                    placeholderPaddingLeft={'8px'}
                    isSearchIcon={true}
                    searchIconWidth={'min-content'}
                    margin={'20px 10px 18px 10px'}
                    fontSize={'16px'}
                    placeHolderFontFamily={'AvenirNextWorld Regular'}
                    iconColor={'#140F4B'}
                    fontWeight={'bold'}
                    handleKeyPress={handleSearchKeyDown}
                    onBlur={handleBlur}
                    clearSearch={handleClearSearch}
                    background={'none'}
                    enterkeyhint={'go'}
                    iconPaddingLeft={'0px'}
                />
            )}
            <FilterPopover
                id={filterPopoverId}
                open={isFilterPopoverOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                filterPopOverTopPosition={bannerHeight ? `${parseInt(bannerHeight) + 130}px` : '130px'}
            >
                <Filter id="home-calendarpanel-filter-component" onClose={handleClose} bannerHeight={bannerHeight} />
            </FilterPopover>
        </>
    );
};
export default Panel;
